import React, { PureComponent } from 'react'
import { Spin, Button, Form, Select, Row, Col, Input, DatePicker, Switch, message, Table } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { adminList, systemMessageList, appPush } from '_src/api/api'

const { Search } = Input
const { TextArea } = Input
const { RangePicker } = DatePicker
const { Option } = Select

@Form.create({ name: '' })
class Message extends PureComponent {
  constructor () {
    super()
    this.state = {
      admins: [],

      isLoading: true,

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0,
        current: 1,
      },

      list: [],

      columns: [
        {
          title: <span>推送编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>消息标题</span>,
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: <span>发布时间</span>,
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: <span>发布人员</span>,
          align: 'center',
          dataIndex: 'admin',
          render: item => item.name
        },
        {
          title: <span>操作</span>,
          align: 'center',
          width: 300,
          render: item => <div>
            <Link to={{ pathname: '/app/message/detail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button type="primary" icon="eye">查看</Button></Link>
            <Link to={{ pathname: '/app/message/post?id=' + item.id }} target="_blank"><Button icon="edit" style={{marginRight: 10}}>修改</Button></Link>
          </div>,
        },
      ]

    }
  }
  componentDidMount () {
    adminList().then(res => {
      this.setState({ admins: res.data.content })
    })
    const { params } = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({ isLoading: true })
    systemMessageList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 搜索标题
  commonChange = (value, key) => {
    const { params } = this.state
    params.pageNum = 0
    if (value) {
      if (key === 'name') {
        const { admins } = this.state
        const cur = admins.filter(item => item.id === value)[0]
        value = cur.name
      }
      params[key] = value
    } else {
      delete params[key]
    }
    this.loadList(params)
  }

  // 时间切换
  timerChange = (e) => {
    const { params } = this.state
    params.pageNum = 0
    if (e.length) {
      params.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      params.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    } else {
      delete params.createStart
      delete params.createEnd
    }
    this.setState({ params })
    this.loadList(params)
  }

  // 跳转详情判断
  switchChange = (jump) => {
    this.setState({ jump })
  }

  // 查看详情
  detail = (id) => {
    const { list } = this.state
    const obj = list.filter(item => item.id === id)[0]
    if (obj.parameters) {
      let params = JSON.parse(obj.parameters)
      obj.params = params
      obj.keys = Object.keys(params)
    }
    this.setState({
      detailInfo: obj,
      DetailVisible: true,
    })
  }

  deteilModal (info) {
    return (
      <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
        <Form.Item label="推送人员：" className='flex'>
          <Input value={info.publisher} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送时间：" className='flex'>
          <Input value={info.createAt} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送标题：" className='flex'>
          <Input value={info.title} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="描述内容：" className='flex'>
          <Input value={info.content} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="是否跳转内容" className='flex'>
          <Switch checked={!!info.parameters} checkedChildren="有详情" unCheckedChildren="无详情" />
        </Form.Item>
        {
          info.keys && (
            <Form.Item label="跳转参数" className='flex'>
              <TextArea value={info.params[info.keys[0]]} style={{ width: 300, height: 80 }} autosize={false} readOnly />
            </Form.Item>
          )
        }
      </Form>
    )
  }

  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {
          title: values.title,
          content: values.content,
        }
        if (values.jump) {
          const pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
          if (values.type === 'link' && !pattern.test(values.value)) {
            message.error('跳转链接地址不正确')
            return
          }
          params.parameters = {
            [values.type]: values.value
          }
        }
        const hide = message.loading('发布推送中', 0)
        appPush(params)
          .then(res => {
            const _this = this
            const { params } = this.state
            params.pageNum = 0
            _this.setState({ visible: false })
            hide()
            message.success('推送成功！', 1.2, () => {
              _this.loadList(params)
            })
          })
      }
    })
  }

  render () {
    const { admins, isLoading, columns, list, pageData } = this.state
    return (
      <div className="push-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{ width: 180, marginBottom: 20 }} className="flex-h-a">
            <Link to={{ pathname: '/app/message/post'}} target="_blank" >
              <Button className='creat-station' type="primary" icon="plus" style={{ width: 130 }}>发布消息</Button>
            </Link>
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 340, marginBottom: 20 }} className="flex-h-a">
            <span>推送标题：</span>
            <Search style={{ width: 230 }} placeholder="消息标题搜索" onSearch={(e) => this.commonChange(e, 'title')} enterButton />
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 280, marginBottom: 20 }} className="flex-h-a">
            <span>发布人员：</span>
            <Select style={{ width: 180 }} defaultValue='' onChange={(e) => this.commonChange(e, 'name')}>
              <Option value='' key={0}>全部</Option>
              {admins.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 320, marginBottom: 20 }} className="flex-h-a">
            <span>发布时间：</span>
            <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
          </Col>
        </Row>

        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
      </div>
    )
  }
}

export default Message